import { cloneDeep } from 'lodash';
import {
    SET_NAVIGATION,
    RESET_NAVIGATION,
    TOGGLE_MOBILE_NAVIGATION,
} from 'vue/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';


const NAVIGATION_LEVEL_STRUCT = Object.freeze({ idx: -1, item: {} });
const NAVIGATION_STRUCT = Object.freeze(Array(3).fill(cloneDeep(NAVIGATION_LEVEL_STRUCT)));


/**
 * The mutations available in the module
 */
const mutations = {
    [SET_NAVIGATION](state, { level, idx, item }) {
        state.navigation.forEach((navItem, navIdx) => {
            if (navIdx === level) {
                state.navigation.splice(navIdx, 1, {
                    idx,
                    item,
                });
            }

            if (navIdx > level) {
                state.navigation.splice(navIdx, 1, {
                    idx: -1,
                    item: cloneDeep(NAVIGATION_LEVEL_STRUCT),
                });
            }
        });
    },
    [RESET_NAVIGATION](state) {
        state.navigation = cloneDeep(NAVIGATION_STRUCT);
    },
    [TOGGLE_MOBILE_NAVIGATION](state, { isOpen }) {
        state.mobileNavigation.isOpen = isOpen;
    },
};

/**
 * The state of the module
 */
const state = {
    navigation: cloneDeep(NAVIGATION_STRUCT),
    mobileNavigation: {
        isOpen: false,
    },
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/main-nav/index.js